export default __webpack_public_path__ + "static/media/TaskManager.b02e35e8.png";